import React, { useEffect, useState } from 'react';
import BoxWrapper from '../boxwra';
import axios from 'axios';
import DesignInGSTR9BReport from "../GSTR-9B_recon.module.css";
import ConfirmationDialog from '../../../Sales/TDSReconciliationSale/ConfirmationDailog';
import { Snackbar, Alert } from '@mui/material';

const apiUrl = process.env.REACT_APP_BACKEND_BASE_URL;

function Nine({ handleBack, updateTableData, data }) {
  const [tableData, setTableData] = useState(data);
  const [inputData, setInputData] = useState({});
  const [tableName, setTableName] = useState("9.Details of tax paid as declared in returns filed during the financial year");
  const [saveDailog, setSaveDailogOpen] = useState(false);
  const [unsavedChanges, setUnsavedChanges] = useState(false);
  const [confirmBack, setConfirmBack] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  // const submitHandle = () => {
  //   updateTableData(tableName, tableData);
  //   setUnsavedChanges(false);
  //   setSaveDailogOpen(false);
  //   setSnackbarOpen(true);
  // };

  const submitHandle = () => {
  // Create a new array with calculated values injected into "Other" and "Penalty" rows
  const dataToSubmit = tableData.map((item, index) => {
    const isOtherOrPenalty = item.name === "Other" || item.name === "Penalty";
    
    if (!isOtherOrPenalty) {
      return item; // Normal rows remain unchanged
    }

    // Calculate live values for Other/Penalty rows
    const paidThroughCash = safeParseFloat(item.paid_through_itc || 0);
    const taxPayable = safeParseFloat(item.tax_payble || 0);
    const taxFieldsSum = 
      safeParseFloat(item.igst || 0) + 
      safeParseFloat(item.cgst || 0) + 
      safeParseFloat(item.sgst || 0) + 
      safeParseFloat(item.cess || 0);
    
    const totalTaxPaid = taxFieldsSum; // For Other/Penalty: sum of tax fields
    const difference = taxPayable - totalTaxPaid;

    // Inject the calculated values into the row object
    return {
      ...item,
      total_tax_paid: totalTaxPaid,
      difference: difference,
      paid_through_itc: paidThroughCash // Keep original cash value
    };
  });

  // Send the complete data with accurate calculated totals
  updateTableData(tableName, dataToSubmit);

  setUnsavedChanges(false);
  setSaveDailogOpen(false);
  setSnackbarOpen(true);
};

  const handleBackButton = () => {
    if (unsavedChanges) {
      setConfirmBack(true);
    } else {
      handleBack();
    }
  };

  const confirmBackHandle = () => {
    submitHandle();
    handleBack();
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarOpen(false);
  };

  // Helper function to safely parse values for calculations
  const safeParseFloat = (value) => {
    if (!value || value === '' || value === '-') {
      return 0; // Return 0 for incomplete values during typing
    }

    // Convert to string to safely use string methods
    const stringValue = String(value);
    if (stringValue.endsWith('.')) {
      return 0; // Return 0 for incomplete decimal values during typing
    }

    const parsed = parseFloat(value);
    return isNaN(parsed) ? 0 : parsed;
  };

  const formatRupee = (value, isManualInput = false) => {
    // For manual type fields, if value is empty, null, undefined, or 0, return empty string
    if (isManualInput && (!value || value === 0 || value === '0' || value === '0.00')) {
      return '';
    }

    if (!value && value !== 0) return '';

    // Check if the value has decimal places
    const hasDecimal = value.toString().includes('.');
    const decimalPlaces = hasDecimal ? value.toString().split('.')[1]?.length || 0 : 0;

    const formatter = new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: hasDecimal && decimalPlaces > 0 ? Math.min(decimalPlaces, 2) : 0,
      maximumFractionDigits: 2,
    });
    return formatter.format(value).replace('INR', '₹');
  };

  const parseRupee = (value) => {
    if (!value) return '';
    // Allow only digits, one decimal point, and optional leading negative sign
    let cleaned = value.replace(/[^0-9.-]/g, '');
    // Ensure only one decimal point
    const parts = cleaned.split('.');
    if (parts.length > 2) {
      cleaned = parts[0] + '.' + parts.slice(1).join('');
    }
    // Ensure only one negative sign at the beginning
    if (cleaned.startsWith('-')) {
      cleaned = '-' + cleaned.substring(1).replace(/-/g, '');
    } else {
      cleaned = cleaned.replace(/-/g, '');
    }
    return cleaned;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const [itemName, field] = name.split('.');

    // Clean the input value but allow intermediate states like "-", "5.", etc.
    const cleanedValue = parseRupee(value);

    setTableData((prevData) =>
      prevData.map((item) =>
        item.name === itemName
          ? { ...item, [field]: cleanedValue }
          : item
      )
    );

    setUnsavedChanges(true);
  };

  // Function to check if a field should be non-editable and gray
  const isFieldNonEditable = (index, field) => {
    // S.No. 1 (index 0): CESS
    if (index === 0 && field === 'cess') return true;
    
    // S.No. 2 (index 1): State Tax and CESS
    if (index === 1 && (field === 'sgst' || field === 'cess')) return true;
    
    // S.No. 3 (index 2): Central Tax and CESS
    if (index === 2 && (field === 'cgst' || field === 'cess')) return true;
    
    // S.No. 4 (index 3): CESS, State and Integrated Tax
    if (index === 3 && (field === 'cess' || field === 'sgst' || field === 'igst')) return true;
    
    // S.No. 5 to 8 (index 4-7): CESS, State, Central and Integrated Tax
    if (index >= 4 && index <= 7 && (field === 'cess' || field === 'sgst' || field === 'cgst' || field === 'igst')) return true;
    
    return false;
  };

  const renderTableRows = () => {
  const getRowColor = (index) => {
    const colors = ['#e0e7ff', '#e9d5ff', '#f3e8ff', '#ede9fe', '#ddd6fe'];
    return colors[index % colors.length];
  };

  return tableData.map((item, index) => {
    const isManualInputRow = item.manual_type !== false;

    // Only for "Other" and "Penalty" → auto-calculate Total Tax Paid & Difference
    const isOtherOrPenalty = item.name === "Other" || item.name === "Penalty";

    const paidThroughCash = safeParseFloat(item.paid_through_itc || 0); // User-entered value
    const taxPayable = safeParseFloat(item.tax_payble || 0);

    const totalTaxPaid = isOtherOrPenalty ? paidThroughCash : safeParseFloat(item.total_tax_paid || 0);
    const difference = isOtherOrPenalty ? (taxPayable - totalTaxPaid) : safeParseFloat(item.difference || item.diff_between_tax_payable_and_paid || 0);

    return (
      <div
        key={index}
        style={{
          display: 'grid',
          gridTemplateColumns: '60px 1fr 120px 120px 110px 110px 110px 110px 120px 120px',
          gap: '8px',
          alignItems: 'center',
          padding: '8px 10px',
          borderBottom: '1px solid #f1f5f9',
          backgroundColor: index % 2 === 0 ? '#ffffff' : '#f8fafc',
          borderRadius: '6px',
          marginBottom: '2px',
          minHeight: '50px',
          minWidth: '1200px',
        }}
      >
        <span style={{ color: '#1e293b', fontSize: '13px', fontWeight: '600', textAlign: 'center', padding: '8px 6px', backgroundColor: getRowColor(index), borderRadius: '6px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          {index + 1}
        </span>
        <span style={{ color: '#334155', fontSize: '13px', padding: '8px 12px', backgroundColor: '#f1f5f9', borderRadius: '6px', wordBreak: 'break-word', textAlign: 'left', display: 'flex', alignItems: 'center', minHeight: '34px' }}>
          {item.name}
        </span>

        {/* Tax Payable */}
        <input type="text" className="blue-color" name={`${item.name}.tax_payble`}
          value={isManualInputRow ? (item.tax_payble === '' || item.tax_payble === '-' || String(item.tax_payble).endsWith('.') ? item.tax_payble : formatRupee(safeParseFloat(item.tax_payble), true)) : formatRupee(item.tax_payble) || ''}
          onChange={handleInputChange} readOnly={!isManualInputRow}
          style={{ color: '#1e293b', fontWeight: '500', fontSize: '13px', textAlign: 'right', padding: '8px 12px', backgroundColor: !isManualInputRow ? '#f0f0f0' : '#ecfdf5', border: '1px solid #e2e8f0', borderRadius: '6px', outline: 'none', cursor: !isManualInputRow ? 'not-allowed' : 'text', minHeight: '34px', boxSizing: 'border-box', width: '100%' }}
          onFocus={(e) => { if (isManualInputRow) e.target.value = item.tax_payble || ''; }}
          onBlur={(e) => { if (isManualInputRow) { const v = parseRupee(e.target.value); e.target.value = v && !v.endsWith('.') ? formatRupee(safeParseFloat(v), true) : v; setTableData(prev => prev.map(i => i.name === item.name ? { ...i, tax_payble: v } : i)); }}}
        />

        {/* Paid Through Cash - FULLY MANUAL & EDITABLE (as before) */}
        <input type="text" className="blue-color" name={`${item.name}.paid_through_itc`}
          value={isManualInputRow ? (item.paid_through_itc === '' || item.paid_through_itc === '-' || String(item.paid_through_itc).endsWith('.') ? item.paid_through_itc : formatRupee(safeParseFloat(item.paid_through_itc), true)) : formatRupee(item.paid_through_itc) || ''}
          onChange={handleInputChange} readOnly={!isManualInputRow}
          style={{ color: '#1e293b', fontWeight: '500', fontSize: '13px', textAlign: 'right', padding: '8px 12px', backgroundColor: !isManualInputRow ? '#f0f0f0' : '#ecfdf5', border: '1px solid #e2e8f0', borderRadius: '6px', outline: 'none', cursor: !isManualInputRow ? 'not-allowed' : 'text', minHeight: '34px', boxSizing: 'border-box', width: '100%' }}
          onFocus={(e) => { if (isManualInputRow) e.target.value = item.paid_through_itc || ''; }}
          onBlur={(e) => { if (isManualInputRow) { const v = parseRupee(e.target.value); e.target.value = v && !v.endsWith('.') ? formatRupee(safeParseFloat(v), true) : v; setTableData(prev => prev.map(i => i.name === item.name ? { ...i, paid_through_itc: v } : i)); }}}
        />

        {/* IGST, CGST, SGST, CESS - unchanged */}
        {['igst', 'cgst', 'sgst', 'cess'].map((field) => {
          const isNonEditable = isFieldNonEditable(index, field);
          const fieldEditable = isManualInputRow && !isNonEditable;
          return (
            <input
              key={`${item.name}.${field}`}
              type="text"
              className="blue-color"
              name={`${item.name}.${field}`}
              value={isNonEditable ? '' : (fieldEditable ? (item[field] === '' || item[field] === '-' || String(item[field]).endsWith('.') ? item[field] : formatRupee(safeParseFloat(item[field]), true)) : formatRupee(item[field]) || '')}
              onChange={handleInputChange}
              readOnly={!fieldEditable}
              style={{ color: '#1e293b', fontWeight: '500', fontSize: '13px', textAlign: 'right', padding: '8px 12px', backgroundColor: isNonEditable ? '#d3d3d3' : (!isManualInputRow ? '#f0f0f0' : '#ecfdf5'), border: '1px solid #e2e8f0', borderRadius: '6px', outline: 'none', cursor: !fieldEditable ? 'not-allowed' : 'text', minHeight: '34px', boxSizing: 'border-box', width: '100%' }}
              onFocus={(e) => { if (fieldEditable) e.target.value = item[field] || ''; }}
              onBlur={(e) => { if (fieldEditable) { const v = parseRupee(e.target.value); e.target.value = v && !v.endsWith('.') ? formatRupee(safeParseFloat(v), true) : v; setTableData(prev => prev.map(i => i.name === item.name ? { ...i, [field]: v } : i)); }}}
            />
          );
        })}

        {/* Total Tax Paid - AUTO for Other/Penalty */}
        <input
          type="text"
          value={formatRupee(totalTaxPaid) || ''}
          readOnly
          style={{ color: '#1e293b', fontWeight: '500', fontSize: '13px', textAlign: 'right', padding: '8px 12px', backgroundColor: '#f0f0f0', border: '1px solid #e2e8f0', borderRadius: '6px', outline: 'none', cursor: 'not-allowed', minHeight: '34px', boxSizing: 'border-box', width: '100%' }}
        />

        {/* Difference - AUTO for Other/Penalty */}
        <input
          type="text"
          value={formatRupee(difference) || ''}
          readOnly
          style={{ color: '#1e293b', fontWeight: '500', fontSize: '13px', textAlign: 'right', padding: '8px 12px', backgroundColor: '#f0f0f0', border: '1px solid #e2e8f0', borderRadius: '6px', outline: 'none', cursor: 'not-allowed', minHeight: '34px', boxSizing: 'border-box', width: '100%' }}
        />
      </div>
    );
  });
};

//   const renderTableRows = () => {
//   const getRowColor = (index) => {
//     const colors = ['#e0e7ff', '#e9d5ff', '#f3e8ff', '#ede9fe', '#ddd6fe'];
//     return colors[index % colors.length];
//   };

//   // Pre-calculate derived values without triggering state updates during render
//   const processedData = tableData.map((item, index) => {
//     const isManualInputRow = item.manual_type !== false;

//     // Default values
//     let paidThroughCash = safeParseFloat(item.paid_through_itc);
//     let totalTaxPaid = safeParseFloat(item.total_tax_paid);
//     let difference = safeParseFloat(item.difference || item.diff_between_tax_payable_and_paid);

//     if (item.name === "Other" || item.name === "Penalty") {
//       const cashSum =
//         safeParseFloat(item.igst) +
//         safeParseFloat(item.cgst) +
//         safeParseFloat(item.sgst) +
//         safeParseFloat(item.cess);

//       paidThroughCash = cashSum;
//       totalTaxPaid = cashSum;
//       difference = safeParseFloat(item.tax_payble) - cashSum;
//     }

//     return {
//       ...item,
//       isManualInputRow,
//       index,
//       calculated: {
//         paidThroughCash,
//         totalTaxPaid,
//         difference,
//       },
//     };
//   });

//   return processedData.map((item) => {
//     const { calculated, isManualInputRow, index } = item;

//     return (
//       <div
//         key={index}
//         style={{
//           display: 'grid',
//           gridTemplateColumns: '60px 1fr 120px 120px 110px 110px 110px 110px 120px 120px',
//           gap: '8px',
//           alignItems: 'center',
//           padding: '8px 10px',
//           borderBottom: '1px solid #f1f5f9',
//           backgroundColor: index % 2 === 0 ? '#ffffff' : '#f8fafc',
//           borderRadius: '6px',
//           marginBottom: '2px',
//           minHeight: '50px',
//           minWidth: '1200px',
//         }}
//       >
//         <span
//           style={{
//             color: '#1e293b',
//             fontSize: '13px',
//             fontWeight: '600',
//             textAlign: 'center',
//             padding: '8px 6px',
//             backgroundColor: getRowColor(index),
//             borderRadius: '6px',
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//           }}
//         >
//           {index + 1}
//         </span>

//         <span
//           style={{
//             color: '#334155',
//             fontSize: '13px',
//             padding: '8px 12px',
//             backgroundColor: '#f1f5f9',
//             borderRadius: '6px',
//             wordBreak: 'break-word',
//             textAlign: 'left',
//             display: 'flex',
//             alignItems: 'center',
//             minHeight: '34px',
//           }}
//         >
//           {item.name}
//         </span>

//         {/* Tax Payable */}
//         <input
//           type="text"
//           className="blue-color"
//           name={`${item.name}.tax_payble`}
//           value={isManualInputRow
//             ? (item.tax_payble === '' || item.tax_payble === '-' || String(item.tax_payble).endsWith('.')
//                 ? item.tax_payble
//                 : formatRupee(safeParseFloat(item.tax_payble), true))
//             : formatRupee(item.tax_payble) || ''}
//           onChange={handleInputChange}
//           readOnly={!isManualInputRow}
//           style={{
//             color: '#1e293b',
//             fontWeight: '500',
//             fontSize: '13px',
//             textAlign: 'right',
//             padding: '8px 12px',
//             backgroundColor: !isManualInputRow ? '#f0f0f0' : '#ecfdf5',
//             border: '1px solid #e2e8f0',
//             borderRadius: '6px',
//             outline: 'none',
//             cursor: !isManualInputRow ? 'not-allowed' : 'text',
//             minHeight: '34px',
//             boxSizing: 'border-box',
//             width: '100%',
//           }}
//           onFocus={(e) => { if (isManualInputRow) e.target.value = item.tax_payble || ''; }}
//           onBlur={(e) => {
//             if (isManualInputRow) {
//               const cleanedVal = parseRupee(e.target.value);
//               const numVal = safeParseFloat(cleanedVal);
//               e.target.value = cleanedVal === '' || cleanedVal === '-' || String(cleanedVal).endsWith('.')
//                 ? cleanedVal
//                 : formatRupee(numVal, true);

//               setTableData(prev => prev.map(it =>
//                 it.name === item.name ? { ...it, tax_payble: cleanedVal } : it
//               ));
//             }
//           }}
//         />

//         {/* Paid Through ITC - For Other/Penalty, show calculated cash sum */}
//         <input
//           type="text"
//           value={formatRupee(
//             item.name === "Other" || item.name === "Penalty"
//               ? calculated.paidThroughCash
//               : item.paid_through_itc
//           ) || ''}
//           readOnly
//           style={{
//             color: '#1e293b',
//             fontWeight: '500',
//             fontSize: '13px',
//             textAlign: 'right',
//             padding: '8px 12px',
//             backgroundColor: '#f0f0f0',
//             border: '1px solid #e2e8f0',
//             borderRadius: '6px',
//             outline: 'none',
//             cursor: 'not-allowed',
//             minHeight: '34px',
//             boxSizing: 'border-box',
//             width: '100%',
//           }}
//         />

//         {/* IGST, CGST, SGST, CESS */}
//         {['igst', 'cgst', 'sgst', 'cess'].map((field) => {
//           const isNonEditable = isFieldNonEditable(index, field);
//           const fieldEditable = isManualInputRow && !isNonEditable;

//           return (
//             <input
//               key={`${item.name}.${field}`}
//               type="text"
//               className="blue-color"
//               name={`${item.name}.${field}`}
//               value={isNonEditable
//                 ? ''
//                 : fieldEditable
//                   ? (item[field] === '' || item[field] === '-' || String(item[field]).endsWith('.')
//                       ? item[field]
//                       : formatRupee(safeParseFloat(item[field]), true))
//                   : formatRupee(item[field]) || ''}
//               onChange={handleInputChange}
//               readOnly={!fieldEditable}
//               style={{
//                 color: '#1e293b',
//                 fontWeight: '500',
//                 fontSize: '13px',
//                 textAlign: 'right',
//                 padding: '8px 12px',
//                 backgroundColor: isNonEditable ? '#d3d3d3' : (!isManualInputRow ? '#f0f0f0' : '#ecfdf5'),
//                 border: '1px solid #e2e8f0',
//                 borderRadius: '6px',
//                 outline: 'none',
//                 cursor: !fieldEditable ? 'not-allowed' : 'text',
//                 minHeight: '34px',
//                 boxSizing: 'border-box',
//                 width: '100%',
//               }}
//               onFocus={(e) => { if (fieldEditable) e.target.value = item[field] || ''; }}
//               onBlur={(e) => {
//                 if (fieldEditable) {
//                   const cleanedVal = parseRupee(e.target.value);
//                   const numVal = safeParseFloat(cleanedVal);
//                   e.target.value = cleanedVal === '' || cleanedVal === '-' || String(cleanedVal).endsWith('.')
//                     ? cleanedVal
//                     : formatRupee(numVal, true);

//                   setTableData(prev => prev.map(it =>
//                     it.name === item.name ? { ...it, [field]: cleanedVal } : it
//                   ));
//                 }
//               }}
//             />
//           );
//         })}

//         {/* Total Tax Paid */}
//         <input
//           type="text"
//           value={formatRupee(calculated.totalTaxPaid) || ''}
//           readOnly
//           style={{
//             color: '#1e293b',
//             fontWeight: '500',
//             fontSize: '13px',
//             textAlign: 'right',
//             padding: '8px 12px',
//             backgroundColor: '#f0f0f0',
//             border: '1px solid #e2e8f0',
//             borderRadius: '6px',
//             outline: 'none',
//             cursor: 'not-allowed',
//             minHeight: '34px',
//             boxSizing: 'border-box',
//             width: '100%',
//           }}
//         />

//         {/* Difference */}
//         <input
//           type="text"
//           value={formatRupee(calculated.difference) || ''}
//           readOnly
//           style={{
//             color: '#1e293b',
//             fontWeight: '500',
//             fontSize: '13px',
//             textAlign: 'right',
//             padding: '8px 12px',
//             backgroundColor: '#f0f0f0',
//             border: '1px solid #e2e8f0',
//             borderRadius: '6px',
//             outline: 'none',
//             cursor: 'not-allowed',
//             minHeight: '34px',
//             boxSizing: 'border-box',
//             width: '100%',
//           }}
//         />
//       </div>
//     );
//   });
// };

  // const renderTableRows = () => {
  //   const getRowColor = (index) => {
  //     const colors = ['#e0e7ff', '#e9d5ff', '#f3e8ff', '#ede9fe', '#ddd6fe'];
  //     return colors[index % colors.length];
  //   };

  //   return tableData.map((item, index) => {
  //     const isManualInputRow = item.manual_type !== false;
  //        // Calculate values for "Other" and "Penalty" rows
  //     let calculatedPaidThroughCash = item.paid_through_itc;
  //     let calculatedTotalTaxPaid = item.total_tax_paid;
  //     let calculatedDifference = item.difference || item.diff_between_tax_payable_and_paid;
      
  //     if (item.name === "Other" || item.name === "Penalty") {
  //       // Paid Through Cash = Sum of IGST + CGST + SGST + CESS
  //       calculatedPaidThroughCash = safeParseFloat(item.igst) + 
  //                                    safeParseFloat(item.cgst) + 
  //                                    safeParseFloat(item.sgst) + 
  //                                    safeParseFloat(item.cess);
        
  //       // Total Tax Paid = Same as Paid Through Cash (no ITC component)
  //       calculatedTotalTaxPaid = calculatedPaidThroughCash;
        
  //       // Difference = Tax Payable - Total Tax Paid
  //       calculatedDifference = safeParseFloat(item.tax_payble) - calculatedTotalTaxPaid;
  //     }

  //     return (
  //       <div
  //         key={index}
  //         style={{
  //           display: 'grid',
  //           gridTemplateColumns: '60px 1fr 120px 120px 110px 110px 110px 110px 120px 120px',
  //           gap: '8px',
  //           alignItems: 'center',
  //           padding: '8px 10px',
  //           borderBottom: '1px solid #f1f5f9',
  //           backgroundColor: index % 2 === 0 ? '#ffffff' : '#f8fafc',
  //           borderRadius: '6px',
  //           marginBottom: '2px',
  //           minHeight: '50px',
  //           minWidth: '1200px',
  //         }}
  //       >
  //         <span
  //           style={{
  //             color: '#1e293b',
  //             fontSize: '13px',
  //             fontWeight: '600',
  //             textAlign: 'center',
  //             padding: '8px 6px',
  //             backgroundColor: getRowColor(index),
  //             borderRadius: '6px',
  //             display: 'flex',
  //             alignItems: 'center',
  //             justifyContent: 'center',
  //           }}
  //         >
  //           {index + 1}
  //         </span>
  //         <span
  //           style={{
  //             color: '#334155',
  //             fontSize: '13px',
  //             padding: '8px 12px',
  //             backgroundColor: '#f1f5f9',
  //             borderRadius: '6px',
  //             wordBreak: 'break-word',
  //             textAlign: 'left',
  //             display: 'flex',
  //             alignItems: 'center',
  //             minHeight: '34px',
  //           }}
  //         >
  //           {item.name}
  //         </span>
  //         <input
  //           type="text"
  //           className="blue-color"
  //           name={`${item.name}.tax_payble`}
  //           value={isManualInputRow ? (item.tax_payble === '' || item.tax_payble === '-' || String(item.tax_payble).endsWith('.') ? item.tax_payble : formatRupee(safeParseFloat(item.tax_payble), true)) : formatRupee(item.tax_payble) || ''}
  //           onChange={handleInputChange}
  //           readOnly={!isManualInputRow}
  //           style={{
  //             color: '#1e293b',
  //             fontWeight: '500',
  //             fontSize: '13px',
  //             textAlign: 'right',
  //             padding: '8px 12px',
  //             backgroundColor: !isManualInputRow ? '#f0f0f0' : '#ecfdf5',
  //             border: '1px solid #e2e8f0',
  //             borderRadius: '6px',
  //             outline: 'none',
  //             cursor: !isManualInputRow ? 'not-allowed' : 'text',
  //             minHeight: '34px',
  //             boxSizing: 'border-box',
  //             width: '100%',
  //           }}
  //           onFocus={(e) => {
  //             if (isManualInputRow) {
  //               e.target.value = item.tax_payble || '';
  //               e.target.style.borderColor = '#88d8a3';
  //               e.target.style.boxShadow = '0 0 0 2px rgba(136, 216, 163, 0.1)';
  //             }
  //           }}
  //           onBlur={(e) => {
  //             if (isManualInputRow) {
  //               const rawVal = e.target.value;
  //               const cleanedVal = parseRupee(rawVal);
  //               const numVal = safeParseFloat(cleanedVal);
  //               const stringVal = String(cleanedVal || '');
  //               const finalDisplay = (cleanedVal === '' || cleanedVal === '-' || stringVal.endsWith('.')) ? cleanedVal : formatRupee(numVal, true);
  //               e.target.value = finalDisplay;
  //               setTableData((prevData) =>
  //                 prevData.map((it) =>
  //                   it.name === item.name
  //                     ? { ...it, tax_payble: cleanedVal }
  //                     : it
  //                 )
  //               );
  //               e.target.style.borderColor = '#e2e8f0';
  //               e.target.style.boxShadow = 'none';
  //             }
  //           }}
  //         />
  //         <input
  //           type="text"
  //           className="blue-color"
  //           name={`${item.name}.paid_through_itc`}
  //           value={isManualInputRow ? (item.paid_through_itc === '' || item.paid_through_itc === '-' || String(item.paid_through_itc).endsWith('.') ? item.paid_through_itc : formatRupee(safeParseFloat(item.paid_through_itc), true)) : formatRupee(item.paid_through_itc) || ''}
  //           onChange={handleInputChange}
  //           readOnly={!isManualInputRow}
  //           style={{
  //             color: '#1e293b',
  //             fontWeight: '500',
  //             fontSize: '13px',
  //             textAlign: 'right',
  //             padding: '8px 12px',
  //             backgroundColor: !isManualInputRow ? '#f0f0f0' : '#ecfdf5',
  //             border: '1px solid #e2e8f0',
  //             borderRadius: '6px',
  //             outline: 'none',
  //             cursor: !isManualInputRow ? 'not-allowed' : 'text',
  //             minHeight: '34px',
  //             boxSizing: 'border-box',
  //             width: '100%',
  //           }}
  //           onFocus={(e) => {
  //             if (isManualInputRow) {
  //               e.target.value = item.paid_through_itc || '';
  //               e.target.style.borderColor = '#88d8a3';
  //               e.target.style.boxShadow = '0 0 0 2px rgba(136, 216, 163, 0.1)';
  //             }
  //           }}
  //           onBlur={(e) => {
  //             if (isManualInputRow) {
  //               const rawVal = e.target.value;
  //               const cleanedVal = parseRupee(rawVal);
  //               const numVal = safeParseFloat(cleanedVal);
  //               const stringVal = String(cleanedVal || '');
  //               const finalDisplay = (cleanedVal === '' || cleanedVal === '-' || stringVal.endsWith('.')) ? cleanedVal : formatRupee(numVal, true);
  //               e.target.value = finalDisplay;
  //               setTableData((prevData) =>
  //                 prevData.map((it) =>
  //                   it.name === item.name
  //                     ? { ...it, paid_through_itc: cleanedVal }
  //                     : it
  //                 )
  //               );
  //               e.target.style.borderColor = '#e2e8f0';
  //               e.target.style.boxShadow = 'none';
  //             }
  //           }}
  //         />
  //         {['igst', 'cgst', 'sgst', 'cess'].map((field) => {
  //           const isNonEditable = isFieldNonEditable(index, field);
  //           const fieldEditable = isManualInputRow && !isNonEditable;
            
  //           return (
  //             <input
  //               key={`${item.name}.${field}`}
  //               type="text"
  //               className="blue-color"
  //               name={`${item.name}.${field}`}
  //               value={isNonEditable ? '' : (fieldEditable ? (item[field] === '' || item[field] === '-' || String(item[field]).endsWith('.') ? item[field] : formatRupee(safeParseFloat(item[field]), true)) : formatRupee(item[field]) || '')}
  //               onChange={handleInputChange}
  //               readOnly={!isManualInputRow || isNonEditable}
  //               style={{
  //                 color: '#1e293b',
  //                 fontWeight: '500',
  //                 fontSize: '13px',
  //                 textAlign: 'right',
  //                 padding: '8px 12px',
  //                 backgroundColor: isNonEditable ? '#d3d3d3' : (!isManualInputRow ? '#f0f0f0' : '#ecfdf5'),
  //                 border: '1px solid #e2e8f0',
  //                 borderRadius: '6px',
  //                 outline: 'none',
  //                 cursor: !isManualInputRow || isNonEditable ? 'not-allowed' : 'text',
  //                 minHeight: '34px',
  //                 boxSizing: 'border-box',
  //                 width: '100%',
  //               }}
  //               onFocus={(e) => {
  //                 if (fieldEditable) {
  //                   e.target.value = item[field] || '';
  //                   e.target.style.borderColor = '#88d8a3';
  //                   e.target.style.boxShadow = '0 0 0 2px rgba(136, 216, 163, 0.1)';
  //                 }
  //               }}
  //               onBlur={(e) => {
  //                 if (fieldEditable) {
  //                   const rawVal = e.target.value;
  //                   const cleanedVal = parseRupee(rawVal);
  //                   const numVal = safeParseFloat(cleanedVal);
  //                   const stringVal = String(cleanedVal || '');
  //                   const finalDisplay = (cleanedVal === '' || cleanedVal === '-' || stringVal.endsWith('.')) ? cleanedVal : formatRupee(numVal, true);
  //                   e.target.value = finalDisplay;
  //                   setTableData((prevData) =>
  //                     prevData.map((it) =>
  //                       it.name === item.name
  //                         ? { ...it, [field]: cleanedVal }
  //                         : it
  //                     )
  //                   );
  //                   e.target.style.borderColor = '#e2e8f0';
  //                   e.target.style.boxShadow = 'none';
  //                 }
  //               }}
  //             />
  //           );
  //         })}
  //         <input
  //           type="text"
  //           value={formatRupee(item.total_tax_paid) || ''}
  //           readOnly
  //           style={{
  //             color: '#1e293b',
  //             fontWeight: '500',
  //             fontSize: '13px',
  //             textAlign: 'right',
  //             padding: '8px 12px',
  //             backgroundColor: '#f0f0f0',
  //             border: '1px solid #e2e8f0',
  //             borderRadius: '6px',
  //             outline: 'none',
  //             cursor: 'not-allowed',
  //             minHeight: '34px',
  //             boxSizing: 'border-box',
  //             width: '100%',
  //           }}
  //         />
  //         <input
  //           type="text"
  //           value={formatRupee(item.difference) || ''}
  //           readOnly
  //           style={{
  //             color: '#1e293b',
  //             fontWeight: '500',
  //             fontSize: '13px',
  //             textAlign: 'right',
  //             padding: '8px 12px',
  //             backgroundColor: '#f0f0f0',
  //             border: '1px solid #e2e8f0',
  //             borderRadius: '6px',
  //             outline: 'none',
  //             cursor: 'not-allowed',
  //             minHeight: '34px',
  //             boxSizing: 'border-box',
  //             width: '100%',
  //           }}
  //         />
  //       </div>
  //     );
  //   });
  // };

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <div
        style={{
          backgroundColor: 'white',
          borderRadius: '20px',
          padding: '30px',
          width: '100%',
          boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
        }}
      >
        <BoxWrapper
          backButtonForZohoEnable={true}
          backButton={handleBackButton}
          boxTitle={tableName}
        >
          <p style={{ marginLeft: '10px' }}>
            <span style={{ fontWeight: 'bold' }}>Note: </span> The fields where the system computed values would be modified by more/less 20% shall be highlighted in <span style={{ color: 'red' }}>Red</span> for reference and attention.
          </p>
          <hr style={{ marginLeft: '10px' }} />
        </BoxWrapper>

        <div
          style={{
            maxHeight: 'calc(100vh - 450px)',
            overflowY: 'auto',
            overflowX: 'auto',
            marginTop: '10px',
          }}
        >
          {/* Main Header Row */}
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: '60px 1fr 120px 120px 440px 120px 120px',
              gap: '8px',
              alignItems: 'center',
              padding: '8px 10px',
              borderBottom: '1px solid #e2e8f0',
              backgroundColor: '#f8fafc',
              borderRadius: '6px 6px 0 0',
              minHeight: '50px',
              fontWeight: '600',
              color: '#475569',
              fontSize: '13px',
              position: 'sticky',
              top: '0',
              zIndex: '11',
              minWidth: '1200px',
            }}
          >
            <span
              style={{
                textAlign: 'center',
                padding: '8px 6px',
                backgroundColor: '#e0e7ff',
                borderRadius: '6px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              S.No.
            </span>
            <span
              style={{
                textAlign: 'left',
                padding: '8px 12px',
                backgroundColor: '#f1f5f9',
                borderRadius: '6px',
                wordBreak: 'break-word',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              Description
            </span>
            <span
              style={{
                textAlign: 'right',
                padding: '8px 12px',
                backgroundColor: '#f1f5f9',
                borderRadius: '6px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
              }}
            >
              Tax payable (₹)
            </span>
            <span
              style={{
                textAlign: 'right',
                padding: '8px 12px',
                backgroundColor: '#f1f5f9',
                borderRadius: '6px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
              }}
            >
              Paid Through Cash (₹)
            </span>
            <span
              style={{
                textAlign: 'center',
                padding: '8px 12px',
                backgroundColor: '#f1f5f9',
                borderRadius: '6px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              Paid Through ITC (₹)
            </span>
            <span
              style={{
                textAlign: 'right',
                padding: '8px 12px',
                backgroundColor: '#f1f5f9',
                borderRadius: '6px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
              }}
            >
              Total Tax Paid (₹)
            </span>
            <span
              style={{
                textAlign: 'right',
                padding: '8px 12px',
                backgroundColor: '#f1f5f9',
                borderRadius: '6px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
              }}
            >
              Difference (₹)
            </span>
          </div>

          {/* Sub Header Row */}
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: '60px 1fr 120px 120px 110px 110px 110px 110px 120px 120px',
              gap: '8px',
              alignItems: 'center',
              padding: '8px 10px',
              borderBottom: '2px solid #e2e8f0',
              backgroundColor: '#f8fafc',
              borderRadius: '0 0 6px 6px',
              marginBottom: '2px',
              minHeight: '50px',
              fontWeight: '600',
              color: '#475569',
              fontSize: '13px',
              position: 'sticky',
              top: '50px',
              zIndex: '10',
              minWidth: '1200px',
            }}
          >
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span
              style={{
                textAlign: 'right',
                padding: '8px 12px',
                backgroundColor: '#f1f5f9',
                borderRadius: '6px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
              }}
            >
              Integrated Tax (₹)
            </span>
            <span
              style={{
                textAlign: 'right',
                padding: '8px 12px',
                backgroundColor: '#f1f5f9',
                borderRadius: '6px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
              }}
            >
              Central Tax (₹)
            </span>
            <span
              style={{
                textAlign: 'right',
                padding: '8px 12px',
                backgroundColor: '#f1f5f9',
                borderRadius: '6px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
              }}
            >
              State/UT Tax (₹)
            </span>
            <span
              style={{
                textAlign: 'right',
                padding: '8px 12px',
                backgroundColor: '#f1f5f9',
                borderRadius: '6px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
              }}
            >
              CESS (₹)
            </span>
            {/* <span
              style={{
                textAlign: 'right',
                padding: '8px 12px',
                backgroundColor: '#f1f5f9',
                borderRadius: '6px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
              }}
            >
              Total Tax Paid (₹)
            </span>
            <span
              style={{
                textAlign: 'right',
                padding: '8px 12px',
                backgroundColor: '#f1f5f9',
                borderRadius: '6px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
              }}
            >
              Difference (₹)
            </span> */}
          </div>

          {tableData && tableData.length >= 1 ? (
            renderTableRows()
          ) : (
            <div style={{ textAlign: 'center', color: '#64748b', padding: '20px' }}>
              No Data Found!
            </div>
          )}
        </div>

        <div
          style={{
            marginTop: '20px',
            padding: '15px',
            backgroundColor: '#f8fafc',
            borderRadius: '8px',
            borderTop: '2px solid #e2e8f0',
          }}
        >
          <p style={{ margin: '0', fontSize: '14px', color: '#64748b', textAlign: 'center' }}>
            Total Records: {tableData?.length || 0}
          </p>
        </div>

        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            marginTop: '20px',
            gap: '10px',
          }}
        >
          <button
            type="button"
            className="button-primary"
            onClick={() => setSaveDailogOpen(true)}
            style={{
              padding: '10px 20px',
              background: 'linear-gradient(135deg, #ffd3a5 0%, #fd9853 50%, #e8a87c 100%)',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              fontSize: '14px',
              fontWeight: '600',
              cursor: 'pointer',
              boxShadow: '0 4px 12px rgba(255, 211, 165, 0.3)',
              transition: 'all 0.2s ease',
            }}
            onMouseOver={(e) => {
              e.target.style.transform = 'translateY(-1px)';
              e.target.style.boxShadow = '0 6px 16px rgba(255, 211, 165, 0.4)';
            }}
            onMouseOut={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 12px rgba(255, 211, 165, 0.3)';
            }}
          >
            Save
          </button>
        </div>
      </div>

      <ConfirmationDialog
        open={saveDailog}
        onClose={() => setSaveDailogOpen(false)}
        onConfirm={submitHandle}
        title="Confirm Save"
        text="Do you want to save your changes? This action will update the current data."
      />

      <ConfirmationDialog
        open={confirmBack}
        onConfirm={confirmBackHandle}
        onClose={() => handleBack()}
        title="Unsaved Changes"
        text="You have unsaved changes. Do you want to leave without saving?"
      />

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity="success"
          sx={{ width: '100%' }}
        >
          Data saved successfully!
        </Alert>
      </Snackbar>
    </div>
  );
}

export default Nine;